<template>
  <nav class="navigation" role="navigation">
    <ul>
      <li class="logo">
        <router-link to="intro">ACCUEIL</router-link>
      </li>
      <li>
        <router-link to="about">À PROPOS</router-link>
      </li>
      <li>
        <router-link to="services">SERVICES</router-link>
      </li>
      <li>
        <router-link to="works">FOLIO</router-link>
      </li>
      <li class="contact">
        <router-link to="contact">CONTACT</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'navigationTop',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Template_Navigation_Top.vue